/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */

var productCardMarkupPage = `<div class="swym-wishlist-grid">
   {{#products}}
   <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
     <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
       <span class="swym-icon swym-heart">
       </span>
     </button>
     <div class="swym-wishlist-image-wrapper">
       <img alt="" class="swym-wishlist-image" src="{{iu}}">
     </div>
     <button class="swym-is-button">
       <div class="swym-title swym-title-1">
         {{dt}}
       </div>
     </button>
      <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer"></div>
     <div class="swym-product-price swym-text swym-text-1">
       <div class="swym-product-final-price swym-value">
         {{cu}}{{pr}}
       </div>
       {{#variantinfo}}
       <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer dilimeter">
          &nbsp;│&nbsp;
       </div>
       {{/variantinfo}}
       <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer vinfo">
       {{variantinfo}}
       </div>
     </div>
   </a>
   {{/products}}
</div>`;

var productCardMarkup = `<div class="swym-wishlist-grid wishlist-grid-desktop">
   {{#products}} 
   <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
     <div class="flex modal-wishlist-items">
        <div class="swym-wishlist-image-wrapper">
            <img alt="" class="swym-wishlist-image" src="{{iu}}">
        </div>
        <div class="swym-wishlist-product-details">
            <div class="swym-title swym-title-1">
                {{dt}}
            </div>
            <div class="swym-product-price swym-text swym-text-1">
                <div class="swym-product-final-price swym-value">
                  {{cu}}{{pr}}
                </div>
            </div>
            <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
             Remove
           </button>
        </div>
     </div>
   </a>
   {{/products}}
</div>`;


function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
		console.log("Successfully added product to cart.", c);
	}, function(e) {
		console.log(e);
	});
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi){
				window._swat.removeFromWishList(product, function() {
					swymRenderWishlist(window._swat);
					if (typeof window.updateSwymWishlistCount === 'function') {
						window.updateSwymWishlistCount(window._swat);
					}
				});
			}
		});
	})
}

function swymRenderWishlist(swat) {
	swat.fetch(function(products) {
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
        var wishlistContentsContainerPage = document.getElementById("wishlist-items-container-page");
        var wishlistCount = document.getElementById("wishlistcount");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p);
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
      
		if(wishlistContentsContainer){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		}

        var productCardsMarkupPage = SwymUtils.renderTemplateString(productCardMarkupPage, {
			products: formattedWishlistedProducts
		});

        var wishListTag = document.querySelector('.custom-wishlist-a')
        var productCount = formattedWishlistedProducts.length;

        try {
          localStorage.setItem('ts_wishlist_count', String(productCount));
        } catch (e) {}
      
        if(wishlistContentsContainerPage){
			wishlistContentsContainerPage.innerHTML = productCardsMarkupPage;
			attachClickListeners();
          if (productCount === 0){
             wishlistContentsContainerPage.innerHTML = `<div style="width:100%;text-align:center;"><h2 class="h1">Your Wishlist Is Currently Empty</h2></div>`;
          }
		}

        if (wishlistCount) {
          wishlistCount.innerHTML = productCount;
          wishlistCount.style.display = productCount === 0 ? 'none' : '';
        }
        document.querySelectorAll('.js-wishlist-count').forEach(function (el) {
          el.textContent = String(productCount);
          el.style.display = productCount === 0 ? 'none' : '';
        });
        if (wishListTag) {
          if (productCount === 0) {
            wishListTag.removeAttribute('onmouseover');
          } else if (typeof refreshWishlistItems === 'function') {
            wishListTag.setAttribute('onmouseover', 'refreshWishlistItems()');
          }
        }
        if (productCount > 3) {
          var wlGridList = document.querySelector('.wishlist-grid-desktop');
          if (wlGridList) {
            wlGridList.style.maxHeight = '470px';
            wlGridList.style.overflowY = 'scroll';
          }
        }
      
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymRenderWishlist);

if (window._swat) {
	swymRenderWishlist(window._swat);
}

